function CTDDossierpage() {
  return (
    <>
      <div className="flex items-center gap-2 mb-6">
        <span className="w-4 h-4 rounded-full bg-sky-300"></span>
        <h3 className="text-lg font-bold text-[#05326D]">
          4. CTD Dossier – Common Technical Document
        </h3>
      </div>

      <p className="text-md font-bold text-[#05326D] mb-4">
        Region: Global (ICH-compliant countries)
      </p>
      <p className="text-[#05326D] mt-2">Purpose: Standardized format for drug submissions  </p>

      <p className="text-[#05326D] mb-4 mt-2">Applicable To: WHO, China, Japan, South Africa, Australia, etc.</p>


      <p className="text-md font-bold text-[#05326D] mb-4">
        Key Components:
      </p>
      <p className="ml-2 mt-2 text-[#05326D]">- Modules 1–5 with country-specific adaptations</p>
      <p className="ml-2 mt-2 text-[#05326D]">- DMF structured in CTD format (Open/Closed parts)</p>
      <p className="ml-2 mt-2 text-[#05326D]">- WHO prequalification support for global access</p>


      <p className="text-md font-bold text-[#05326D] mb-4 mt-4">
        Filing Notes: </p>

      <p className="ml-2 mt-2 text-[#05326D]">- Submission portals vary (e.g., PMDA in Japan, EDQM, WHO PQ portal)</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Requires alignment with local regulatory guidance</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Lifecycle includes revisions, renewals, and query responses</p>

      <hr className="border-t border-gray-300 mb-8 mt-8" />
      <p className="text-md font-bold text-[#05326D] mb-4 mt-4">
        Strategic Tip from FDAC: </p>
      <p className="text-[#05326D]">For global dossier success, FDAC recommends:</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Early alignment of DMF/ASMF/CEP with target market requirements</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Robust eCTD publishing and validation workflows</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Lifecycle planning for post-approval changes and renewals</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Cloud-based collaboration for real-time dossier management</p>
    </>

  );
}

export default CTDDossierpage;
